import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';

import { useWrapper } from 'src/utils/axios';
import { getResultadoPergunta } from 'src/app/services/votacao';
import {
  ETipoOpcao,
  Pergunta,
  ResultadoPergunta,
  EFormaApresResultado,
  OpcaoComUnidade
} from 'src/app/types/votacao';

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const SimpleColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const Column = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  padding: 0 1rem;
  margin-bottom: 0.5rem;
  width: 100%;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 0 0.5rem;
  }
`;

const Block = styled.div`
  display: block;
  width: 100%;
`;

const Text = styled(Typography)`
  color: #707070;
  white-space: nowrap;
`;

const TextBold = styled(Text)`
  font-weight: bold;
`;

const bgColors = ['#a3a1fb', '#5ee2a0', '#ff6565', '#5587FC', '#6C63FF', '#00004D', '#808040'];

interface Props {
  item: Pergunta;
  type?: EFormaApresResultado;
}

export default ({ item, type }: Props) => {
  const result = useWrapper<ResultadoPergunta>();
  const [decimals, setDecimals] = useState(0);

  const refresh = () => {
    result.exec(
      getResultadoPergunta(item.codigoVotacao, item.codigoPergunta),
      (res) => {setDecimals(res.quantCasasDecimaisResultado)}
    );
  }

  useEffect(() => {
    refresh();
    return () => result.cancel();
  }, []);

  const getValidVotes = () => {
    return result.payload?.opcoes.filter(t => t.tipoOpcao === ETipoOpcao.OpcaoValida) || [];
  }

  const getPercent = (item: OpcaoComUnidade) => {
    return ((item.quantVotos / (result.payload?.baseQuantVotos || 0)) * 100) || 0;
  }

  const getDecimals = (item: OpcaoComUnidade) => {
    let value = ((item.quantVotos / (result.payload?.baseQuantVotos || 0)) * 100) || 0;
    return value % 1
  }


  return (
    <Column>
      {
        getValidVotes().map((t, i) => (
          <Column key={i}>
            <Row>
              <SimpleColumn style={{ width: '100%', marginRight: '1rem' }}>
                <Text variant="caption" style={{ marginRight: '1rem' }}>{t.textoResposta}</Text>
                <Block>
                  <LinearProgress key={i} variant="determinate" value={getPercent(t)} />
                </Block>
              </SimpleColumn>
              <SimpleColumn style={{ alignItems: 'end' }}>
                {
                  type === EFormaApresResultado.Percentual_Votos_Sobre_Quant_Unidades
                    || type === EFormaApresResultado.Percentual_Votos_Sobre_Quant_Votos
                    ? (<></>)
                    : (<Text variant="caption">{t.quantVotos + (t.quantVotos > 1 ? ' votos' : ' voto')}</Text>)
                }
                  <TextBold variant="caption">{getPercent(t).toFixed(decimals)}%</TextBold>
              </SimpleColumn>
            </Row>
          </Column>
        ))
      }
    </Column>
  );
}
